<template>
  <div class="form-item-container" :class="{ 'first-form-item': form_item_order === 0 && layout_mode === 'all_on_one_page' }">
    <div class="text-container">
      <div class="text-primary-language">
        {{ text_label_lang1 }}
      </div>
      <div class="text-secondary-language" v-if="bilingue">
        {{ text_label_lang2 }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextLabel',
  props: {
    text_label_lang1: {
      type: String,
      default: ''
    },
    text_label_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    form_item_order: {
      type: Number,
      default: -1
    },
    layout_mode: {
      type: String,
      default: 'all_on_one_page'
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.form-item-container {

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  align-items: center;
  justify-items: center;
  padding: 2em 5% 2em 5%;
  color: $gorate-secondary;

  .text-container {

    .text-primary-language {
      grid-row: 1;
      /* font-size: 3em; */
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .text-secondary-language {
      grid-row: 2;
      /* font-size: 1.5em; */
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

}
</style>
